// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__hQE0T","obliqueLineWrap":"membershipbadge_obliqueLineWrap__TF6Kr","obliqueLine":"membershipbadge_obliqueLine__1p4B1"};